module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[47]46.69aeace.woff2";